<div class="row" *ngIf="operacao && model; else carregando">

  <div class="bn-form-group col-md-12" *ngIf="modoEdicao && !emInclusao && campoHabilitado('alteracaoClienteFinal')">
    <label class="form-label block"><b>Alteração de cliente final</b></label>
    <input type="checkbox" class="form-check checkbox-gigante" name="indicadorAlteracaoClienteFinal{{iope}}"
      [ngModel]="operacao.indicadorAlteracaoClienteFinal == 'S'?true:false"
      (ngModelChange)="atribuiIndicadorAlteracaoClienteFinal(operacao, $event ? 'S' : 'N')"
      [disabled]="!modalidadeGarantiaDTO?.permiteAditivoSubstituicaoBeneficiario" />
  </div>
  <div class="row" *ngIf="modoEdicao && modoAditivo">
    <div class="bn-form-group col-md-12">
      <label class="form-label"><b>Data de formalização</b></label>
      <bn-datepicker name="dataCelebracaoAditivo" [(ngModel)]="operacao.dataCelebracaoAditivo" required>
      </bn-datepicker>
    </div>
  </div>
  <div class="row">
    <div class="bn-form-group col-md-3">
      <label class="form-label"><b>Id. operação crédito</b></label>
      <input type="text" class="form-control" value="{{operacao.id}}" [bnComparacaoA]="operacao.id"
        [bnComparacaoB]="model.id" disabled />
    </div>
    <div class="bn-form-group col-md-3" *ngIf="operacao.codigoTipoOperacao == 'L'">
      <label class="form-label"><b>Id. operação agente</b></label>
      <input type="text" class="form-control" name="idOperacaoAgente{{iope}}" [(ngModel)]="operacao.idOperacaoAgente"
        [disabled]="!emInclusao" required />
    </div>
    <div class="bn-form-group col-md-3" *ngIf="operacao.codigoTipoOperacao == 'R'">
      <label class="form-label"><b>Id. protocolo BNDES </b></label>
      <input type="text" class="form-control" name="idProtocoloBNDES" [(ngModel)]="operacao.idProtocoloBNDES"
        [bnComparacaoA]="operacao.idProtocoloBNDES" [bnComparacaoB]="model.idProtocoloBNDES" [disabled]="!emInclusao"
        required />
    </div>
    <div class="bn-form-group col-md-2">
      <label class="form-label"><b>Tipo de operação</b></label>
      <input type="text" class="form-control" value="{{operacao.codigoTipoOperacao == 'L' ? 'Credito Livre' : 'Repasse'}}"
        [bnComparacaoA]="operacao.codigoTipoOperacao" [bnComparacaoB]="model.codigoTipoOperacao" disabled />
    </div>
    <div class="bn-form-group col-md-3">
      <label class="form-label"><b>Data/hora de envio</b></label>
      <input type="text" class="form-control" value="{{operacao.dataEnvio | date:'dd/MM/yyyy HH:mm:ss'}}"
        [bnComparacaoA]="operacao.dataEnvio | date:'dd/MM/yyyy HH:mm:ss'"
        [bnComparacaoB]="model.dataEnvio | date:'dd/MM/yyyy HH:mm:ss'" disabled />
    </div>
    <div class="bn-form-group col-md-3">
      <label class="form-label"><b>Data de contratação</b></label>
      <bn-datepicker name="dataContratacao" [(ngModel)]="operacao.dataContratacao"
        (ngModelChange)="onChangeDataContratacao($event)"
        [disabled]="!campoHabilitado('dataContratacao')"
        bnComparacaoA="{{operacao.dataContratacao | bnMask:'DD/MM/AAAA'}}"
        bnComparacaoB="{{model.dataContratacao | bnMask:'DD/MM/AAAA'}}" required></bn-datepicker>
    </div>
    <div class="bn-form-group col-md-2" *ngIf="!modoEdicao && !emInclusao">
      <label class="form-label"><b>Valor do crédito</b></label>
      <input type="text" class="form-control" value="{{operacao.detalhe?.valorCredito | bnMask:'MOEDA'}}"
        [bnComparacaoA]="operacao.valorCredito" [bnComparacaoB]="model.valorCredito" readonly disabled />
    </div>
    <div class="bn-form-group col-md-2">
      <label class="form-label"><b>Valor da operação</b></label>
      <input type="text" class="form-control" name="valorOperacao{{iope}}" [(ngModel)]="operacao.valorOperacao"
        bnMask="MOEDA" [disabled]="!campoHabilitado('valorOperacao')" [bnComparacaoA]="operacao.valorOperacao"
        [bnComparacaoB]="model.valorOperacao" required />
    </div>
    <div class="bn-form-group col-md-3">
      <label class="form-label" for="percentualGarantidoSelect"><b>Percentual garantido <i class="fa fa-question-circle help-subtitulo" placement="bottom"
        ngbTooltip="Percentual garantido da operação"></i></b></label>
      <select *ngIf="(modoEdicao || emInclusao)" class="form-select" id="percentualGarantidoSelect"
          name="percentualGarantidoSelect" required #percentualGarantidoSelect="ngModel" [(ngModel)]="operacao.percentualGarantido"
          (change)="atribuiPercentualGarantido($event.target.value)">
          <option value=""></option>
          <option [value]="percentualPorModalidade" *ngFor="let percentualPorModalidade of percentuaisPorModalidade">{{percentualPorModalidade | bnMask: 'DECIMAL': '2'}}
          </option>
        </select>
      <input type="text" class="form-control" name="percentualGarantido" value="{{operacao.percentualGarantido | bnMask: 'DECIMAL': '2'}}"
          *ngIf="(!modoEdicao && !emInclusao)" readonly disabled
        bnMask="DECIMAL" casasDecimais="2" [bnComparacaoA]="operacao.percentualGarantido"
        [bnComparacaoB]="model.percentualGarantido" />
    </div>
    <div class="bn-form-group col-md-2" *ngIf="!modoEdicao && !emInclusao">
      <label class="form-label"><b>Perc. honra <i class="fa fa-question-circle help-subtitulo" placement="bottom"
        ngbTooltip="Percentual garantido a ser honrado"></i></b></label>
      <input type="text" class="form-control" value="{{operacao.detalhe?.percentualGarantidoASerHonrado | bnMask:'DECIMAL': '2'}}"
        [bnComparacaoA]="operacao.detalhe?.percentualGarantidoASerHonrado"
        [bnComparacaoB]="model.detalhe?.percentualGarantidoASerHonrado" disabled/>
    </div>
    <div class="bn-form-group col-md-2" *ngIf="!modoEdicao && !emInclusao">
      <label class="form-label"><b>Valor garantido</b></label>
      <input type="text" class="form-control" value="{{operacao.detalhe?.valorGarantido | bnMask:'MOEDA'}}"
        [bnComparacaoA]="operacao.detalhe?.valorGarantido"
        [bnComparacaoB]="model.detalhe?.valorGarantido" disabled/>
    </div>
    <div class="bn-form-group col-md-2" *ngIf="!modoEdicao && !emInclusao">
      <label class="form-label"><b>Prazo Carência <i class="fa fa-question-circle help-subtitulo" placement="bottom"
        ngbTooltip="Prazo de carência em meses"></i></b></label>
      <input type="text" class="form-control"
        [value]="( operacao.detalhe?.prazoCarenciaEmMeses ? operacao.detalhe?.prazoCarenciaEmMeses : '' )"
        disabled />
    </div>
    <div class="bn-form-group col-md-3" *ngIf="!modoEdicao && !emInclusao">
      <label class="form-label"><b>Prazo Amortização <i class="fa fa-question-circle help-subtitulo" placement="bottom"
        ngbTooltip="Prazo de amortização em meses"></i></b></label>
      <input type="text" class="form-control"
        [value]="( operacao.detalhe?.prazoAmortizacaoEmMeses ? operacao.detalhe?.prazoAmortizacaoEmMeses : '' )"
        disabled />
    </div>
    <div class="bn-form-group col-md-3" *ngIf="!modoEdicao && !emInclusao">
        <label class="form-label">
            <b>
                Limite Adicional
                <i class="fa fa-question-circle help-subtitulo"
                  placement="bottom"
                  ngbTooltip="Limite adicional para programas de repasse">
                </i>
            </b>
        </label>

        <input type="text"
              class="form-control"
              [value]="operacao.detalhe?.limiteAdicional ?? ''"
              disabled />
    </div>
    <div class="bn-form-group col-md-6" *ngIf="!modoEdicao && !emInclusao">
      <label class="form-label"><b>IPOC</b></label>
      <input type="text" class="form-control"
        [value]="operacao.ipoc ? operacao.ipoc : ''"
        disabled />
    </div>
    <div class="bn-form-group col-md-6" *ngIf="!modoEdicao && !emInclusao">
      <label class="form-label"><b>IPOC Cooperativa <i class="fa fa-question-circle help-subtitulo" placement="bottom"
        ngbTooltip="Aplicável apenas para cooperativas de crédito"></i></b></label>
      <input type="text" class="form-control"
        [value]="operacao.ipocCooperativa ? operacao.ipocCooperativa : ''"
        disabled />
    </div>
    <div class="bn-form-group col-md-2" *ngIf="!modoEdicao && !emInclusao">
      <label class="form-label"><b>Prazo Total <i class="fa fa-question-circle help-subtitulo" placement="bottom"
        ngbTooltip="Prazo total em meses"></i></b></label>
      <input type="text" class="form-control"
        [value]="( operacao.detalhe?.prazoEmMeses ? operacao.detalhe?.prazoEmMeses : '' )" disabled />
    </div>
    <div class="bn-form-group col-md-2" *ngIf="!modoEdicao && !emInclusao">
      <label class="form-label"><b>Fator K</b></label>
      <input type="text" class="form-control" value="{{operacao.detalhe?.fatorK | bnMask:'DECIMAL': '2'}}"
        [bnComparacaoA]="operacao.detalhe?.fatorK" [bnComparacaoB]="model.detalhe?.fatorK" disabled />
    </div>
    <div class="bn-form-group col-md-3" *ngIf="operacao.codigoTipoOperacao == 'R' && exibirPeriodicidadeAmortizacao()">
      <label class="form-label"><b>Periodicidade Amortização</b></label>
      <input type="text" class="form-control" value="{{retornaPeriodicidadeAmortizacaoRepasse()}}" disabled />
    </div>
    <div class="bn-form-group col-md-2" *ngIf="!modoEdicao && !emInclusao">
      <label class="form-label"><b>Valor ECG <i class="fa fa-question-circle help-subtitulo" placement="bottom"
        ngbTooltip="Valor ECG já considerando o desconto no encargo, quando aplicável"></i></b></label>
      <input type="text" class="form-control" value="{{operacao.detalhe?.valorEcg | bnMask:'MOEDA'}}"
        [bnComparacaoA]="operacao.detalhe?.valorEcg" [bnComparacaoB]="model.detalhe?.valorEcg" disabled />
    </div>
    <div class="bn-form-group col-md-2" *ngIf="operacao.codigoTipoOperacao == 'L'">
      <label class="form-label block"><b>ECG somado à oper.</b></label>
      <input type="checkbox" class="form-check checkbox-gigante" name="ecgDeveSerSomadoAoValorOperacao{{iope}}"
        [ngModel]="operacao.ecgDeveSerSomadoAoValorOperacao == 'S'?true:false"
        (ngModelChange)="operacao.ecgDeveSerSomadoAoValorOperacao=$event?'S':'N'"
        [bnComparacaoA]="operacao.ecgDeveSerSomadoAoValorOperacao" [bnComparacaoB]="model.ecgDeveSerSomadoAoValorOperacao"
        [disabled]="!campoHabilitado('ecgSomadoAOperacao')" />
    </div>
    <div class="bn-form-group col-md-6" *ngIf="operacao.codigoTipoOperacao == 'R'">
      <label class="form-label block"><b>Tipo ECG Repasse</b></label>
      <input type="text" class="form-control" value="{{nomeTipoECGRepasse(operacao.tipoFGI)}}" name="tipoFGI"
        [disabled]="!campoHabilitado('tipoEcgOperacaoRepasse')" />
    </div>
    <div class="bn-form-group col-md-2">
      <label class="form-label"><b>Risco/Perda Esperada<i class="fa fa-question-circle help-subtitulo" placement="bottom"
        ngbTooltip="Percentual de perda esperada do riscoe"></i></b></label>
      <input type="text" class="form-control" name="riscoOperacao{{iope}}" [(ngModel)]="operacao.riscoOperacao"
        [disabled]="(modoAditivo && operacao.indicadorAlteracaoClienteFinal != 'S') || !campoHabilitado('risco')" [bnComparacaoA]="operacao.riscoOperacao"
        pattern="^[A-Za-z]{1,2}$|^[0-9]{1,2}(,[0-9]{0,2})?$"
        [bnComparacaoB]="model.riscoOperacao" />
    </div>
    <div class="bn-form-group col-md-5" *ngIf="operacao.codigoTipoOperacao == 'L'">
      <label class="form-label block" for="modalidadeSelect"><b>Modalidade</b></label>
      <select *ngIf="(modoEdicao || emInclusao) && !modoAditivo && !carregandoModalidades" class="form-select" id="modalidadeSelect"
        name="modalidadeSelect" required #modalidadeSelect="ngModel" [(ngModel)]="operacao.modalidade"
        (change)="onChangeModalidade($event.target.value)"
        [disabled]="!campoHabilitado('modalidadeOperacaoCreditoLivre')">
        <option value=""></option>
        <option [value]="modalidade.id" *ngFor="let modalidade of modalidades">
          {{modalidade.nome}}</option>
      </select>
      <input *ngIf="carregandoModalidades" type="text" class="form-control"
        value="Carregando..." readonly disabled/>
      <input *ngIf="(!modoEdicao && !emInclusao) || (modoEdicao && modoAditivo) && !carregandoModalidades"
        type="text" class="form-control"
        value="{{nomeModalidadeOperacao(operacao.modalidade)}}"
        [bnComparacaoA]="nomeModalidadeOperacao(operacao.modalidade)"
        [bnComparacaoB]="nomeModalidadeOperacao(model.modalidade)" readonly disabled/>
    </div>
    <div class="bn-form-group col-md-3" *ngIf="operacao.codigoTipoOperacao == 'L'">
      <label class="form-label" for="indexadorSelect"><b>Indexador</b></label>
      <select *ngIf="(modoEdicao || emInclusao) && (!modoAditivo || modalidadeFGT()) && !carregandoIndexadores" class="form-select" id="indexadorSelect"
        name="indexadorSelect" required #indexadorSelect="ngModel" [(ngModel)]="operacao.indexadorTaxaJuros"
        [disabled]="!campoHabilitado('indexador')" (change)="atribuiIndexador($event.target.value)">
        <option value=""></option>
        <option [value]="indexador.id" *ngFor="let indexador of indexadores">{{indexador.nome}}
        </option>
      </select>
      <input *ngIf="carregandoIndexadores" type="text" class="form-control"
        value="Carregando..." readonly disabled/>
      <input *ngIf="(!modoEdicao && !emInclusao) || (modoEdicao && (modoAditivo && !modalidadeFGT())) && !carregandoIndexadores"
        type="text" class="form-control"
        value="{{operacao.detalheCreditoLivre?.nomeIndexadorTaxaJuros}}"
        [bnComparacaoA]="operacao.detalheCreditoLivre?.nomeIndexadorTaxaJuros"
        [bnComparacaoB]="model.detalheCreditoLivre?.nomeIndexadorTaxaJuros" readonly disabled/>
    </div>
    <div class="bn-form-group col-md-2" *ngIf="operacao.codigoTipoOperacao == 'L'">
      <label class="form-label"><b>Percentual indexador</b></label>
      <input type="text" class="form-control" name="percentualIndexador{{iope}}"
        [(ngModel)]="operacao.percentualIndexador" bnMask="DECIMAL" casasDecimais="2" [disabled]="!campoHabilitado('percentualIndexador')"
        [bnComparacaoA]="operacao.percentualIndexador" [bnComparacaoB]="model.percentualIndexador" />
    </div>
    <div class="bn-form-group col-md-2" *ngIf="operacao.codigoTipoOperacao == 'L'">
      <label class="form-label"><b>Taxa de juros a.a.</b></label>
      <input type="text" class="form-control" name="taxaEfetivaAnual{{iope}}" [(ngModel)]="operacao.taxaEfetivaAnual"
        bnMask="DECIMAL" casasDecimais="2" [disabled]="!campoHabilitado('taxaEfetivaAnual')" [bnComparacaoA]="operacao.taxaEfetivaAnual"
        [bnComparacaoB]="model.taxaEfetivaAnual" required />
    </div>
    <div class="bn-form-group col-md-3"
      *ngIf="operacao.codigoTipoOperacao == 'L' && !modoEdicao && !emInclusao && !operacao.historico">
      <label class="form-label"><b>Taxa de juros total a.a.</b></label>
      <input type="text" class="form-control" name="taxaJurosEquivalente" [(ngModel)]="operacao.taxaJurosEquivalente"
        bnMask="DECIMAL" casasDecimais="2" disabled />
    </div>
    <div class="bn-form-group" [ngClass]="{'col-md-6': modoEdicao, 'col-md-5': !modoEdicao}"
      *ngIf="operacao.codigoTipoOperacao == 'L'">
      <label class="form-label" for="municipioInvestimentoSelect"><b>Município do investimento</b></label>
      <input *ngIf="campoHabilitado('municipioInvestimento')" type="text" class="form-control"
        id="municipioInvestimentoSelect" required (selectItem)="atribuiMunicipioInvestimento($event)"
        value="{{model.detalheCreditoLivre?.nomeMunicipioInvestimento}}" [ngbTypeahead]="procuraMunicipio"
        [resultFormatter]="formataMunicipio" />
      <input *ngIf="!campoHabilitado('municipioInvestimento')" type="text" class="form-control"
        value="{{operacao.detalheCreditoLivre?.nomeMunicipioInvestimento}}"
        [bnComparacaoA]="operacao.detalheCreditoLivre?.nomeMunicipioInvestimento"
        [bnComparacaoB]="model.detalheCreditoLivre?.nomeMunicipioInvestimento" readonly disabled/>
    </div>
    <div class="bn-form-group col-md-5" *ngIf="operacao.codigoTipoOperacao == 'R' &&  exibirMunicipioInvestimento()">
      <label class="form-label" for="municipioInvestimentoSelect"><b>Município do investimento</b></label>
      <input type="text" class="form-control"
        value="{{retornaNomeMunicipioInvestimentoRepasse()}}" readonly />
  </div>
    <div class="bn-form-group" [ngClass]="{'col-md-6': modoEdicao}"
      *ngIf="operacao.codigoTipoOperacao == 'L' && modoEdicao && emInclusao">
      <label class="form-label" for="opcaoEnvio"><b>Opção de envio *</b></label>
      <div class="row">
        <div class="col-md-4" style="display: flex; flex-direction: row; align-items: flex-start; justify-content: flex-start; gap: 0.5em">
          <input type="radio" name="opcaoEnvio" [(ngModel)]="opcaoEnvio" value="validar" id="consultar-enquadramento"
            [checked]="opcaoEnvio === 'validar' "(change)="atribuirOpcaoEnvio($event.target.value)" />
          <label class="form-label" for="consultar-enquadramento">Consultar enquadramento</label>
        </div>
        <div class="col-md-2" style="display: flex; flex-direction: row; align-items: flex-start; justify-content: flex-start; gap: 0.5em">
          <input type="radio" name="opcaoEnvio" [(ngModel)]="opcaoEnvio" value="contratar" id="opcao-envio-contratar"
            [checked]="opcaoEnvio === 'contratar' " (change)="atribuirOpcaoEnvio($event.target.value)"/>
          <label class="form-label" for="opcao-envio-contratar">Contratar</label>
        </div>
      </div>
    </div>

    <div
      [ngClass]="{'bn-form-group': true, 'col-md-4': operacao.codigoTipoOperacao == 'L' && !operacao.historico, 'col-md-7': operacao.codigoTipoOperacao == 'L' && operacao.historico, 'col-md-5': operacao.codigoTipoOperacao != 'L'}"
      *ngIf="!modoEdicao && !emInclusao">
      <label class="form-label"><b>Estado</b></label>
      <input type="text" class="form-control" value="{{operacao.detalhe?.estado?.nomeEstado}}"
        [disabled]="!modoEdicao && !emInclusao" [bnComparacaoA]="operacao.detalhe?.estado?.nomeEstado"
        [bnComparacaoB]="model.detalhe?.estado?.nomeEstado" />
    </div>
    <div class="bn-form-group col-md-4" *ngIf="operacao.codigoTipoOperacao == 'R'">
      <label class="form-label"><b>Código do programa</b></label>
      <input type="text" class="form-control" value="{{operacao.nomePrograma}}" disabled />
    </div>
    <div [ngClass]="{'bn-form-group': true, 'col-md-6': true}"
      *ngIf="!modoEdicao && !emInclusao">
      <label class="form-label"><b>Motivo</b></label>
      <input type="text" class="form-control" value="{{operacao.detalhe?.estado?.motivoEstado}}"
        [disabled]="!modoEdicao && !emInclusao" [bnComparacaoA]="operacao.detalhe?.estado?.motivoEstado"
        [bnComparacaoB]="model.detalhe?.estado?.motivoEstado" disabled/>
    </div>
    <div [ngClass]="{'bn-form-group': true, 'col-md-6': true}"
      *ngIf="!modoEdicao && !emInclusao && !operacao.historico">
      <label class="form-label"><b>Estado da Solicitação de Honra</b></label>
      <input type="text" class="form-control" value="{{operacao.detalhe?.estadoSolicitacaoHonraAtual?.nomeEstado}}"
        [disabled]="!modoEdicao && !emInclusao" [bnComparacaoA]="operacao.detalhe?.estadoSolicitacaoHonraAtual?.nomeEstado"
        [bnComparacaoB]="model.detalhe?.estadoSolicitacaoHonraAtual?.nomeEstado" />
    </div>
    <div class="bn-form-group col-md-2" *ngIf="!modoEdicao && !emInclusao && !operacao.historico">
      <label class="form-label block"><b>Garantia ativa</b></label>
      <input type="checkbox" class="form-check checkbox-gigante" [checked]="operacao.detalhe?.garantiaAtiva == 'S'"
        [disabled]="!modoEdicao && !emInclusao" />
    </div>
    <div class="bn-form-group col-md-1" *ngIf="!modoEdicao && !emInclusao && !operacao.historico">
      <label class="form-label block"><b>Retificada</b></label>
      <input type="checkbox" class="form-check checkbox-gigante" [checked]="operacao.detalhe?.retificada == 'S'"
        [disabled]="!modoEdicao && !emInclusao" />
    </div>
    <div class="bn-form-group col-md-3" *ngIf="!modoEdicao && !emInclusao && !operacao.historico">
      <label class="form-label block"><b>Honra processada/recuperada</b></label>
      <input type="checkbox" class="form-check checkbox-gigante" [checked]="operacao.detalhe?.honraProcessada == 'S' || operacao.detalhe?.honraRecuperada == 'S'"
        [disabled]="!modoEdicao && !emInclusao" />
    </div>
    <div class="bn-form-group col-md-4" *ngIf="operacao.codigoTipoOperacao == 'L'" >
      <label class="form-label"><b>Taxa de Atualização de Garantia <i class="fa fa-question-circle help-subtitulo" placement="bottom"
        ngbTooltip="Atualizado com os valores existentes na regra retornada do N01"></i></b></label>
      <input type="text" class="form-control" value="{{exibirValorTaxaAtualizacaoGarantia()}}"
          disabled />
    </div>
    <div class="bn-form-group col-md-3" *ngIf="!modoEdicao && !emInclusao && honraComAtualizacaoGarantida && modalidadeGarantiaDTO.sigla == 'FGT'">
      <label class="block form-label"><b>Honra c/atualização Garantia <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                          ngbTooltip="Solicitação de honra realizada com a atualização da garantia"></i></b></label>
      <input type="checkbox" class="form-check checkbox-gigante" [checked]="operacao.tipoRecebimento" [disabled]="!modoEdicao && !emInclusao" />
    </div>
    <div class="bn-form-group col-md-6" *ngIf="operacao.codigoTipoOperacao == 'R'">
      <label class="form-label"><b>Modalidade operacional</b></label>
      <input type="text" class="form-control" value="{{nomeModalidadeOperacional(operacao.idModalidadeOperacionalBndes)}}"
          disabled />
    </div>
    <div class="bn-form-group col-md-3" *ngIf="operacao.codigoTipoOperacao == 'R'">
      <label class="form-label"><b>Data da primeira amortização</b></label>
      <input type="text" class="form-control" value="{{operacao.dataPrimeiraAmortizacao | date: 'dd/MM/yyyy'}}" disabled />
    </div>
    <div class="bn-form-group col-md-3" *ngIf="operacao.codigoTipoOperacao == 'R'">
      <label class="form-label"><b>Data da última amortização</b></label>
      <input type="text" class="form-control" value="{{operacao.dataUltimaAmortizacao | date: 'dd/MM/yyyy'}}" disabled />
    </div>
    <div class="bn-form-group col-md-3" *ngIf="operacao.codigoTipoOperacao == 'R'">
      <label class="form-label"><b>Spread do agente</b></label>
      <input type="text" class="form-control" name="taxaSpreadAgente" [(ngModel)]="operacao.taxaSpreadAgente"
        bnMask="DECIMAL" [casasDecimais]="6" required disabled />
    </div>
    <div class="bn-form-group col-md-3" *ngIf="operacao.codigoTipoOperacao == 'R'">
      <label class="form-label"><b>Registro do transportador de cargas</b></label>
      <input type="text" class="form-control" value="{{operacao.numeroCertificadoRntrc}}" disabled />
    </div>
    <div class="bn-form-group col-md-3" *ngIf="operacao.codigoTipoOperacao == 'R'">
      <label class="form-label"><b>Sistema de cobrança</b></label>
      <input type="text" class="form-control" value="{{operacao.sistemaCobranca}}" disabled />
    </div>
    <div class="bn-form-group col-md-3" *ngIf="operacao.codigoTipoOperacao == 'R'">
      <label class="form-label"><b>Contrato</b></label>
      <div class="input-group">
        <input type="text" class="form-control" value="{{operacao.contratoCobranca}}" disabled />
          <span class="input-group-text" *ngIf="permissaoLinkN03 && operacao.contratoCobranca"><a
              href="/n03_spa/#!/amb-ope/subcredito/documento-nivel/numero/{{operacao.contratoCobranca}}"><i
                class="fa fa-external-link-alt" ngbTooltip="Acessar Operação"></i></a></span>
      </div>
    </div>
    <div class="bn-form-group col-md-2" *ngIf="operacao.codigoTipoOperacao == 'R'">
      <label class="form-label"><b>Sist. Origem</b></label>
      <input type="text" class="form-control" name="sistemaOrigem" [(ngModel)]="operacao.sistemaOrigem"
             [bnComparacaoA]="operacao.sistemaOrigem" [bnComparacaoB]="model.sistemaOrigem" [disabled]="!emInclusao"
             required />
    </div>
    <div class="bn-form-group col-md-4" *ngIf="operacao.codigoTipoOperacao == 'R'">
      <label class="form-label"><b>Porte</b></label>
      <input type="text" class="form-control" value="{{nomePorteRepasse(operacao.idPorteClienteFinal)}}"
        disabled />
    </div>
    <div class="bn-form-group col-md-6" *ngIf="operacao.codigoTipoOperacao == 'R'">
      <label class="form-label"><b>Natureza jurídica</b></label>
      <input type="text" class="form-control" value="{{nomeNaturezaN02(operacao.idNaturezaEmpresa)}}"
        disabled readonly />
    </div>
    <div class="bn-form-group col-md-6" *ngIf="operacao.codigoTipoOperacao == 'R'">
      <label class="form-label"><b>Complemento da natureza jurídica</b></label>
      <input type="text" class="form-control"
        value="{{nomeComplementoNaturezaN02 (operacao.idComplementoNaturezaEmpresa)}}"
        disabled />
    </div>
  </div>
</div>
<ng-template #carregando>
  <div class="loading-pesquisa">
    <i class="bn-loading"></i>
  </div>
</ng-template>
